import { useQuery, UseQueryResult } from 'react-query';
import {CORE_API_SUFFIX, dataFetch, DIGGER_API_SUFFIX} from '../../../axios/customAxios';
import { generateQueryKey } from '../../../constants/hookConstants';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';

interface GAResponse {
        gaMeasurementId: string,
        ga4Secret: string,
}

const useGetGACodes = (
    identifier: string,
): UseQueryResult<ApiResponse<GAResponse>, ApiError<GAResponse>> => {
    const queryParams = new URLSearchParams();

    const queryKey = generateQueryKey(identifier, queryParams);

    return useQuery<ApiResponse<GAResponse>, ApiError<GAResponse>>(
        [`ga_code_${queryKey}`],
        () => dataFetch.get(`${CORE_API_SUFFIX}organization-settings/google-analytics`),
    );
};

export default useGetGACodes;
